import { render, staticRenderFns } from "./RelocationOfChildQuestionnaire.vue?vue&type=template&id=325e0f2e"
import script from "./RelocationOfChildQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./RelocationOfChildQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports